import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authFetch } from '../utils/authFetch';
import Spinner from '../components/Spinner';

const ConstructorDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [constructor, setConstructor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchConstructor = async () => {
            try {
                const data = await authFetch(`${window.REACT_APP_API_ENDPOINT}/api/constructores/${id}`);
                setConstructor(data);
            } catch (err) {
                setError('No se pudo cargar el constructor.');
            } finally {
                setLoading(false);
            }
        };
        fetchConstructor();
    }, [id]);

    if (loading) return <Spinner text="Cargando constructor..." />;
    if (error) return <div className="text-red-500 text-center p-4">{error}</div>;
    if (!constructor) return <div className="text-gray-500 text-center p-4">Constructor no encontrado.</div>;

    return (
        <div className="container mx-auto p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">Detalle del Constructor</h1>
                <button onClick={() => navigate(-1)} className="text-blue-600 hover:underline">← Volver</button>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6">
                <div className="mb-4">
                    <span className="font-semibold">Nombre:</span> {constructor.nombre}
                </div>
                <div className="mb-4">
                    <span className="font-semibold">Descripción:</span> {constructor.descripcion || <span className="text-gray-400">(Sin descripción)</span>}
                </div>
                <div className="mb-4">
                    <span className="font-semibold">Dirección:</span> {constructor.direccion || <span className="text-gray-400">(Sin dirección)</span>}
                </div>
                <div className="mb-4">
                    <span className="font-semibold">Teléfono:</span> {constructor.telefono || <span className="text-gray-400">(Sin teléfono)</span>}
                </div>
                <div className="mb-4">
                    <span className="font-semibold">Email:</span> {constructor.email || <span className="text-gray-400">(Sin email)</span>}
                </div>
                <div className="mb-4">
                    <span className="font-semibold">Coste Mano de Obra (€/hora):</span> {constructor.coste_mano_obra_hora}
                </div>
                <div className="mb-4">
                    <span className="font-semibold">Visibilidad:</span> {constructor.public ? <span className="text-green-700 font-semibold">Público</span> : <span className="text-yellow-700 font-semibold">Privado</span>}
                </div>
                <div className="flex gap-4 mt-6">
                    <Link to={`/constructores/editar/${constructor.id}`} className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600">Editar</Link>
                </div>
            </div>
        </div>
    );
};

export default ConstructorDetailPage; 